<template>
  <PreNavbar/>
  <NavBar/>
  <router-view/>
  <FooterComp/>
</template>

<script>
import FooterComp from './layout/FooterComp.vue';
import NavBar from './layout/NavBar.vue';
import PreNavbar from './layout/PreNavbar.vue';
//import WhatsAppBtn from './components/WhatsAppBtn.vue'

export default {
  name: "App",
  components: {
    PreNavbar,
    NavBar,
    FooterComp,
    //WhatsAppBtn   
  }
};
</script>
